export default (
  {
    $vs,
    title = 'Błąd',
    text = 'Operacja zakończyła się niepowodzeniem',
    color = 'danger',
    position = 'bottom-right',
    time = 3000,
  } = {},
) => {
  $vs.notify({
    title: title,
    text: text,
    color: color,
    position: position,
    time: time,
  });
}
